<template>
  <div class="lff-box">
    <div class="head-box-placeholder"></div>
    <div class="head-box">
      <div class="w1200">
        <div class="logo">
          <a href="https://www.zhongke3.com/"><img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/logo.png" alt="" /></a>
        </div>
        <div class="nav-box">
          <div class="li" v-for="(item, index) in navigation" :key="index" :class="{ on: item.key === currentNav }" @click="setScrollEvent(item.key)">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="box1" id="box1">
      <div class="banner">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/banner.jpg" alt="" />
      </div>
      <div class="w1200">
        <div class="main" :style="{ backgroundImage: `url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/input-bg.png)` }">
          <div class="input-box" id="lia-ding" :class="{ flicker: flicker }">
            <div class="bor-box">
              <img class="mod1" src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/phone.png" alt="" />
              <input class="mod2" v-model="formData.mobile" placeholder="请输入您的手机号" type="text" name="" id="" />
              <img class="mod3" src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/dunpai.png" alt="" />
              <input class="mod4" v-model="formData.msg" placeholder="请输入验证码" type="text" name="" id="" />
              <button class="mod5" @click="sendMsg">
                获取验证码 <span v-if="codeTime != 60">({{ codeTime }})</span>
              </button>
            </div>
            <button class="mod6" @click="onsubmit">点击提交领取</button>
          </div>
        </div>
      </div>
    </div>
    <div class="box2" id="box2">
      <div class="w1200">
        <div class="title">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box22.png" alt="" />
        </div>
        <div class="mian">
          <div class="img">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box21.png" alt="" />
          </div>
          <div class="text">考研应届报考竞争激烈、往届生再战实力强劲，备战难度大幅增加，一战成硕需早做准备！</div>
        </div>
      </div>
    </div>
    <div class="box3" id="box3" :style="{ backgroundImage: `url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box33.png)` }">
      <div class="w1200">
        <div class="title">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box32.png" alt="" />
        </div>
        <div class="main">
          <div class="li-box">
            <div class="li-b" v-for="(item, index) in box3" :key="index">
              <div class="name">{{ item.name }}</div>
              <div class="ul">
                <div class="li" v-for="(each, index) in item.arr" :key="index">
                  <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box31.png" alt="" />
                  <span>{{ each }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="tip" @click="box3Open = true">一键解决备考难题，获取考研策略</div>
        </div>
      </div>
    </div>
    <div class="box2" id="box4">
      <div class="w1200">
        <div class="title">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box41.png" alt="" />
        </div>
        <div class="mian">
          <div class="img">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box42.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="box2" id="box5" style="background-color: #f0f7ff">
      <div class="w1200">
        <div class="title">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box51.png" alt="" />
        </div>
        <div class="mian">
          <div class="img">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box52.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="box6" id="box6">
      <div class="w1200">
        <div class="title">一站式备考指导，带你科学备考，多方位提升</div>
        <div class="mian">
          <div class="line"></div>
          <div class="li-box">
            <div class="li" v-for="(item, index) in box6" :key="index">
              <div class="icon">
                <img class="hover" src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box6icon.png" alt="" />
                <img class="hovera" src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box6icona.png" alt="" />
              </div>
              <div class="li-main">
                <img class="hover" src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box6libg.png" alt="" />
                <img class="hovera" src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box6libga.png" alt="" />
                <div class="name">{{ item.name }}</div>
                <div class="liml"></div>
                <div class="text" v-html="item.text"></div>
                <div class="tip">{{ item.tip }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="tip-box" @click="box3Open = true">免费定制考研规划</div>
      </div>
    </div>
    <div class="side-navigation">
      <div class="min-box" v-if="!sideNavigationOpen" @click="sideNavigationOpen = true" key="min-box">领取礼包</div>
      <transition enter-active-class="animate__animated animate__backInLeft" leave-active-class="animate__animated animate__backOutLeft">
        <div class="big-box" v-if="sideNavigationOpen" key="big-box">
          <i class="el-icon-close" @click="sideNavigationOpen = false"></i>
          <div class="back">
            <div class="ljzx" @click="serviceClick">立即<br />咨询</div>
            <div class="li-box">
              <div class="li" v-for="(item, index) in navigation" :key="index" :class="{ on: item.key === currentNav }">
                <a @click="setScrollEvent(item.key)">{{ item.name }}</a>
              </div>
            </div>
          </div>
          <div class="img-button" @click="setflicker">
            <img @click="setScrollEvent('lia-ding')" src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/img-button.png" alt="" />
          </div>
        </div>
      </transition>
    </div>
    <Dialog class="box3-dialog" title="中课网校" :visible.sync="box3Open" center width="308px">
      <div class="dialog-mian">
        <div class="img-box">
          <div class="bor"><img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/box38.png" alt="" /></div>
        </div>
        <div class="tip">扫码添加老师微信咨询</div>
      </div>
    </Dialog>
    <Dialog class="submit-dialog" title="领取成功！" :visible.sync="dialogVisible" center :show-close="false" width="460px">
      <div class="submitMian">
        中课网校指导老师会在24小时内致电您，给您
        <br />
        发送备考资料，请注意接听电话
      </div>
      <span slot="footer" class="dialog-footer">
        <button @click="dialogVisible = false">确定</button>
      </span>
    </Dialog>
  </div>
</template>
<script>
import { graduateEnroll, sendMsg } from '@/api'
import { phoneValidator } from '@/utils'
import { Dialog } from 'element-ui'
import md5 from 'js-md5'
import { loadScript } from '@/utils/index'
export default {
  data() {
    return {
      formData: {
        mobile: '',
        msg: ''
      },
      box3Open: false,
      dialogVisible: false,
      sideNavigationOpen: true,
      codeTime: 60,
      anchorDom: [],
      currentNav: '',
      flicker: false,
      navigation: [
        { name: '备考策略', key: 'box3' },
        { name: '考研流程', key: 'box4' },
        { name: '科学备考', key: 'box5' },
        { name: '考研班型', key: 'box7' },
        { name: '讲师团队', key: 'box8' },
        { name: '院校咨询', key: 'box9' }
      ],
      box3: [
        {
          name: '在校生考研',
          arr: ['院校/专业选择', '知识梳理琐碎', '专业备考难度大', '备考时间长心态不稳']
        },
        {
          name: '在职考研',
          arr: ['学习基础薄弱', '备考时间紧张', '学习、工作兼顾压力大', '考研信息渠道少']
        },
        {
          name: '中课考研计划',
          arr: ['科学备考计划', '系统知识脉络', '学习效果跟踪', '全程督学陪护']
        }
      ],
      box6: [
        {
          name: '择校',
          text: '择院校定专业<br/>明确学习目标',
          tip: '1V1择校指南'
        },
        {
          name: '规划',
          text: '制定学习计划<br/>科学夯基提升',
          tip: '1V1规划方案'
        },
        {
          name: '学习-基础',
          text: '政/英/数一轮学习夯实基础知识体系',
          tip: '1V1学习指导'
        },
        {
          name: '学习-强化',
          text: '专业课针对复习<br/>专项突破薄弱点',
          tip: '1V1学习指导'
        },
        {
          name: '学习-提升',
          text: '巩固考点，及时查漏攻克重难知识点',
          tip: '1V1学习指导'
        },
        {
          name: '初试',
          text: '了解出题套路<br/>强化应试稳备考',
          tip: '获取初试指南'
        },
        {
          name: '复试&调剂',
          text: '实战打磨技巧</br>巧避复试雷区',
          tip: '复试&调剂策略'
        }
      ]
    }
  },
  created() {
    $(document).scroll(this.scrollEvent)
    //获取所有id box类型id
    this.$nextTick(() => {
      for (let i = 1; i < 1000; i++) {
        let dom = $(`#box${i}`)
        if (!dom[0]) return
        this.anchorDom.push(dom)
      }
    })
  },
  components: {
    Dialog
  },
  methods: {
    box3OpenOpen() {
      this.box3Open = true
    },
    serviceClick() {
      Promise.all([
        loadScript('js', 'https://scripts.easyliao.com/js/easyliao.js', 'body'),
        loadScript('js', 'https://scripts.easyliao.com/34383/84293/lazy.js', 'body')
      ]).then(res => {
        window.open(
          'https://live.easyliao.com/live/chat.do?c=34383&g=48911&config=84293',
          '_blank',
          'height=600,width=800,top=50,left=200,status=yes,toolbar=no,menubar=no,resizable=no,scrollbars=no,location=no,titlebar=no'
        )
      })
    },
    setflicker() {
      this.flicker = true
      setTimeout(() => {
        this.flicker = false
      }, 2400)
    },
    onsubmit() {
      const gt = new Date().getTime().toString()
      graduateEnroll({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData,
        collegeName: '考研网课',
        orign: '自主注册',
        promotedAccount: 'SEO-考研招生简章页'
      }).then(res => {
        this.dialogVisible = true
      })
    },
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
        }
        this.codeTime = codeTime
      }, 1000)
    },
    setScrollEvent(id) {
      if (id === 'box9') {
        this.box3Open = true
        return
      }
      const screen = window.screen.height / 4
      $('html,body').animate({ scrollTop: $(`#${id}`).offset().top - screen }, 1000)
    },
    scrollEvent() {
      const anchor = window.screen.height / 2 + $(document).scrollTop()
      for (const item in this.anchorDom) {
        if (Object.hasOwnProperty.call(this.anchorDom, item)) {
          const element = this.anchorDom[item]
          if (element.offset().top > anchor) {
            return
          } else {
            this.currentNav = element.attr('id')
          }
        }
      }
    }
  },
  beforeDestroy() {
    $(document).unbind('scroll')
  }
}
</script>
<style scoped lang="scss">
.lff-box {
  .box3-dialog {
    .dialog-mian {
      .tip {
        font-size: 18px;
        color: #333333;
        text-align: center;
        margin-top: 24px;
      }

      .img-box {
        display: flex;
        justify-content: center;

        .bor {
          display: flex;
          padding: 6px;

          background: #ffffff;
          border-radius: 6px;
          border: 1px solid #3e71ff;

          img {
            width: 144px;
            height: 144px;
          }
        }
      }
    }

    ::v-deep .el-dialog {
      border-radius: 22px;

      .el-dialog__title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -22px;
        width: 150px;
        line-height: 44px;
        background: linear-gradient(270deg, #3cb4ff 0%, #3867f1 100%);
        border-radius: 22px;
        padding: 0;

        font-size: 20px;
        color: #ffffff;
      }
    }
  }

  .submit-dialog {
    .submitMian {
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      text-align: center;
    }

    .dialog-footer {
      button {
        width: 150px;
        height: 44px;
        background: linear-gradient(270deg, #3cb4ff 0%, #3867f1 100%);
        border-radius: 22px;
        border: none;
        font-size: 20px;
        color: #ffffff;
        cursor: pointer;
      }
    }

    ::v-deep .el-dialog {
      border-radius: 22px;
    }
  }

  .side-navigation {
    position: fixed;
    left: 60px;
    bottom: 200px;
    z-index: 10;

    .min-box {
      position: fixed;
      left: 10px;
      top: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 5px;
      text-align: center;
      cursor: pointer;
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      width: 60px;
      height: 60px;
      line-height: 20px;
      background: linear-gradient(180deg, #ff883c 0%, #f0383c 100%);
      box-shadow: 0px 3px 6px 1px rgba(242, 64, 60, 0.17);
      border-radius: 50%;
    }

    .el-icon-close {
      position: absolute;
      right: 0;
      top: 0;
      font-weight: bold;
      cursor: pointer;
      font-size: 22px;
    }

    .back {
      width: 148px;
      background: linear-gradient(180deg, #fc6c61 0%, #ec4439 100%);
      border-radius: 74px 74px 0 0;
      padding-bottom: 60px;
      padding-top: 17px;

      .ljzx {
        width: 88px;
        height: 88px;
        background: #ffffff;
        box-shadow: 0px 3px 6px 1px rgba(191, 0, 0, 0.16);
        font-size: 20px;
        font-weight: 600;
        color: #f96459;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        cursor: pointer;
      }

      .li-box {
        padding-top: 10px;
        border-bottom: 1px solid #fd9d94;

        .li {
          border-top: 1px solid #fd9d94;
          line-height: 54px;
          font-size: 20px;
          cursor: pointer;

          &.on {
            a {
              background-color: rgba(255, 255, 255, 0.3);
            }
          }

          a {
            display: block;
            color: #ffffff;
            text-align: center;
          }
        }
      }
    }

    .img-button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -40px;
      cursor: pointer;

      img {
        width: 240px;
        animation: rotates 0.6s linear infinite;
      }
    }
  }

  .box6 {
    padding-top: 60px;
    padding-bottom: 60px;

    .title {
      font-size: 28px;
      font-weight: 600;
      color: #333333;
    }

    .mian {
      .line {
        position: relative;
        border: 1px dotted #bebebe;
        top: 44px;
      }

      .li-box {
        display: flex;
        justify-content: space-between;
        margin-top: 74px;

        .li + .li {
          margin-left: 20px;
        }

        .li {
          padding: 18px 14px 20px 14px;
          position: relative;

          &:hover {
            .icon {
              .hovera {
                display: block;
              }

              .hover {
                display: none;
              }
            }

            .li-main {
              .hover {
                display: none;
              }

              .hovera {
                display: block;
              }

              .name,
              .text {
                color: #fff;
              }

              .liml {
                background: #fff;
              }

              .tip {
                background: #fff;
                color: #4468e5;
              }
            }
          }

          .icon {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -43px;

            .hover {
              display: block;
            }

            img {
              width: 24px;
              height: 24px;
              display: none;
            }
          }

          .li-main {
            width: 128px;

            .hovera,
            .hover {
              position: absolute;
              z-index: -1;
              left: 0;
              top: 0;
              display: none;
              width: 154px;
            }

            .hover {
              display: block;
            }

            .name {
              font-size: 20px;
              font-weight: 600;
              color: #333333;
            }

            .liml {
              margin-top: 28px;
              width: 29px;
              height: 3px;
              background: linear-gradient(270deg, #3cb4ff 0%, #3867f1 100%);
            }

            .text {
              height: 78px;
              font-size: 16px;
              font-weight: 400;
              color: #666666;
              margin-top: 10px;
            }

            .tip {
              width: 105px;
              line-height: 25px;
              background: linear-gradient(270deg, #3cb4ff 0%, #3867f1 100%);
              box-shadow: 0px 3px 6px 1px rgba(58, 139, 248, 0.17);
              border-radius: 50px;
              font-size: 14px;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              margin-left: 5px;
            }
          }
        }
      }
    }

    .tip-box {
      width: 437px;
      line-height: 60px;
      background: linear-gradient(244deg, #3cb4ff 0%, #3a89f7 55%, #3867f1 100%);
      box-shadow: 0px 3px 6px 1px rgba(76, 122, 242, 0.35);
      border-radius: 50px;
      font-size: 24px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      margin: 0 auto;
      margin-top: 40px;
      cursor: pointer;
    }
  }

  .box3 {
    background-position: center;
    background-size: 1920px;
    padding-top: 66px;
    padding-bottom: 50px;

    .title {
      text-align: center;

      img {
        height: 92px;
      }
    }

    .main {
      padding-top: 77px;

      .li-box {
        display: flex;
        justify-content: space-between;

        .li-b {
          width: 370px;
          background: #ffffff;
          border-radius: 11px;
          border: 1px solid #707070;
          position: relative;

          .name {
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 252px;
            height: 62px;
            line-height: 62px;
            background: linear-gradient(360deg, #fb392a 0%, #fd6f50 100%);
            border-radius: 50px;
            font-size: 24px;
            color: #ffffff;
            text-align: center;
          }

          .ul {
            padding-top: 70px;
            margin-left: 50px;
            padding-bottom: 40px;

            .li + .li {
              margin-top: 20px;
            }

            .li {
              display: flex;
              align-items: center;
              font-size: 24px;
              color: #333333;

              img {
                width: 38px;
                height: 35px;
              }

              span {
                margin-left: 18px;
              }
            }
          }
        }
      }

      .tip {
        margin: 0 auto;
        margin-top: 50px;
        width: 437px;
        height: 60px;
        line-height: 60px;
        background: linear-gradient(360deg, #fb392a 0%, #fd6f50 100%);
        box-shadow: 0px 3px 6px 1px rgba(76, 122, 242, 0.35);
        border-radius: 50px;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;

        &:hover {
          opacity: 0.6;
        }
      }
    }
  }

  .box2 {
    padding-top: 60px;
    padding-bottom: 60px;

    .title {
      height: 94px;
      text-align: center;
    }

    .mian {
      padding-top: 40px;

      .img {
        width: 1200px;
      }

      .text {
        padding-top: 40px;
        text-align: center;
        font-size: 28px;
        font-weight: 600;
        color: #333333;
        line-height: 40px;
      }
    }
  }

  .box1 {
    .banner {
      position: relative;
      height: 654px;
      overflow: hidden;

      img {
        width: 1920px;
        height: 654px;
        position: absolute;
        left: 50%;
        margin-left: -960px;
      }
    }

    .main {
      background-repeat: no-repeat;
      background-size: 100%;
      padding-left: 325px;
      padding-top: 122px;
      padding-bottom: 40px;

      .input-box {
        display: flex;
        align-items: center;

        &.flicker {
          animation: flicker 0.6s linear infinite;
        }

        .bor-box {
          display: flex;
          align-items: center;
          border-radius: 50px 0 0 50px;
          border: 1px solid #ea6150;
          height: 60px;
          padding-right: 11px;
        }

        .mod1,
        .mod3 {
          width: 29px;
          height: 29px;
          margin-left: 22px;
        }

        .mod2,
        .mod4 {
          line-height: 29px;
          height: 29px;
          width: 150px;
          font-size: 16px;
          color: #666666;
          border: none;
          border-left: 1px solid #cccccc;
          margin-left: 20px;
          padding-left: 0.2em;
        }

        .mod5 {
          width: 112px;
          height: 36px;
          line-height: 36px;
          background: #f3f3f3;
          border-radius: 18px;
          font-size: 13px;
          color: #666666;
          border: none;
          cursor: pointer;

          &:hover {
            opacity: 0.6;
          }
        }

        .mod6 {
          width: 200px;
          height: 62px;
          line-height: 62px;
          background: linear-gradient(230deg, #ff883c 0%, #f0383c 100%);
          border-radius: 0px 40px 40px 0px;
          border: none;
          font-size: 18px;
          font-weight: 600;
          color: #ffffff;
          cursor: pointer;

          &:hover {
            opacity: 0.6;
          }
        }
      }
    }
  }

  .head-box-placeholder {
    height: 96px;
  }

  .head-box {
    box-sizing: border-box;
    padding-top: 20px;
    height: 96px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10;
    background-color: #fff;

    .w1200 {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        img {
          width: 170px;
          height: 50px;
        }
      }

      .nav-box {
        display: flex;

        .li {
          font-size: 16px;
          color: #333333;
          margin-left: 60px;
          cursor: pointer;
          position: relative;

          &:hover,
          &.on {
            color: #4c7af2;
            opacity: 1;

            &::after {
              position: absolute;
              bottom: -14px;
              left: 0;
              content: '';
              width: 100%;
              height: 4px;
              background: #4c7af2;
              border-radius: 2px;
            }
          }
        }
      }
    }
  }
}

@keyframes flicker {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes rotates {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }

  25% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
  }

  50% {
    -webkit-transform: translateY(20px) scale(1.1, 0.9);
    transform: translateY(20px) scale(1.1, 0.9);
  }

  75% {
    ransform: translateY(10px);
  }

  to {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
</style>
